export default "__VITE_PUBLIC_ASSET__6337db86__"